/**
 * @name: viewRouteMap.js
 * @description: 路由汇总文件
 * @author: 温永江
 * @create: 2020/07/28 14:50:53
 * @update: 2020/07/28 14:50:53
 */

// 以下是参考
// 管理中心路由
// systemManagement.js 系统管理
import systemManagement from './systemManagement';
// merchantManagement.js 商户管理
import merchantManagement from './merchantManagement';
// memberManagement.js 会员管理
import memberManagement from './memberManagement';
// marketingManagement.js 营销管理
import marketingManagement from './marketingManagement';
// goodsManagement.js 商品管理
import goodsManagement from './goodsManagement';
// supplyManagement.js 供应管理
import supplyManagement from './supplyManagement';
// tradingRules.js 交易规则
import tradingRules from './tradingRules';
// articleManagement.js 文章管理
import articleManagement from './articleManagement';
// messageManagement.js 消息管理
import messageManagement from './messageManagement';
// financialManagement.js 财务管理
import financialManagement from './financialManagement';
// rebateManagement.js 返利管理
import rebateManagement from './rebateManagement';
// liveManagement.js 直播管理
import liveManagement from './liveManagement';

export default [
  ...systemManagement,
  ...merchantManagement,
  ...memberManagement,
  ...marketingManagement,
  ...goodsManagement,
  ...supplyManagement,
  ...tradingRules,
  ...articleManagement,
  ...messageManagement,
  ...financialManagement,
  ...rebateManagement,
  ...liveManagement
];
